import {Modal as BootstrapModal, ModalHeader, ModalBody} from 'reactstrap'
import {toastr} from 'react-redux-toastr'

import DiplomeForm from '../../Forms/DiplomeForm/DiplomeForm.jsx'
import Modal from '../../../../shared/components//Modals/Modal.jsx'
import SubmitButton from '../../Forms/DiplomeForm/SubmitButton.jsx'

export default class DiplomeModal extends Modal {
  onSubmitSuccess = () => {
    let action = 'créée'
    if (this.props.offset !== undefined) {
      action = 'modifiée'
    }

    toastr.success('La formation a été ' + action + ' avec succès.')
  }

  onSubmit = (values) => {
    const {freelance} = this.props
    const diplomes = [...(this.props.freelance?.diplomes || [])]

    if (this.props.offset !== undefined) {
      diplomes[this.props.offset] = values
    } else {
      diplomes.push(values)
    }

    if (this.props.onSubmit) {
      this.props.onSubmit({freelance: {...freelance, diplomes: diplomes}})
    }

    if (this.props.onClose) {
      this.props.onClose(diplomes)
    }

    this.props.closeModal()
  }

  render() {
    if (!this.props.freelance) {
      return null
    }

    const diplome = (this.props.offset !== undefined && this.props.freelance.diplomes[this.props.offset]) || null

    return (
      <BootstrapModal toggle={this.props.closeModal} isOpen={this.props.isOpen} className="mission-modal modal-lg">
        <ModalHeader toggle={this.props.closeModal}>Diplôme ou Formation</ModalHeader>
        <ModalBody>
          <DiplomeForm
            onSubmitSuccess={this.onSubmitSuccess}
            initialValues={diplome}
            onSubmit={this.onSubmit}
          />
          <div className="text-center">
            <SubmitButton className="btn btn-primary my-3">
              Enregistrer
            </SubmitButton>
          </div>
        </ModalBody>
      </BootstrapModal>
    )
  }
}
